'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { J } from './sell-market-animation';
import { Cm, ym } from './sample-redlines';
import { ProductionIcon } from './deliverable-previews';
export function TechpackOpenItems({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      {...J(e, Cm)}
      className={
        'pd-in flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-4'
      }
    >
      <span
        className={
          'text-ink flex shrink-0 items-center gap-1.5 text-[13px] font-medium'
        }
      >
        <span className={'text-[var(--pd-amber)]'}>
          <ProductionIcon
            name={'circleAlert'}
            on={e >= Cm}
            className={'size-4'}
          />
        </span>
        {translateShowcaseNode(showcaseCopy, 'Still open')}
      </span>
      <ul className={'flex min-w-0 flex-wrap gap-1.5'}>
        {translateShowcaseNode(
          showcaseCopy,
          ym.open.map((e) => (
            <li
              key={e}
              className={
                'text-ink-2 flex h-6 items-center rounded-full bg-[var(--pd-amber-wash)] px-2.5 text-[12px] whitespace-nowrap'
              }
            >
              {translateShowcaseNode(showcaseCopy, e)}
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
export const Em = {
  x: 6,
  y: 30,
  w: 306,
  h: 252,
};
export const Dm = [
  {
    code: 'A',
    name: 'Body width',
    cm: '38.0',
    tol: '0.5',
    at: 1900,
  },
  {
    code: 'B',
    name: 'Body height',
    cm: '30.0',
    tol: '0.5',
    at: 2300,
  },
  {
    code: 'C',
    name: 'Gusset depth',
    cm: '14.0',
    tol: '0.3',
    at: 2700,
  },
  {
    code: 'D',
    name: 'Handle drop',
    cm: '24.0',
    tol: '0.5',
    at: 3100,
  },
  {
    code: 'E',
    name: 'Handle width',
    cm: '2.5',
    tol: '0.1',
    at: 3500,
  },
];
export const Om = (e, t) => String(e >= t);
export function Scene_km({
  d: e,
  t,
  ms: n,
  dashed: r = !1,
  className: i = '',
}) {
  return r ? (
    <path
      d={e}
      data-on={Om(t, n)}
      className={`pd-fade pd-dash ${i}`}
      strokeWidth={'0.9'}
    />
  ) : (
    <path d={e} pathLength={1} data-on={Om(t, n)} className={`pd-line ${i}`} />
  );
}
export function ToteDrawing({ a: e, b: t, t: n, ms: r }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let i = e[0] === t[0],
    a = (e) => (i ? `M${e[0] - 3.5} ${e[1]}h7` : `M${e[0]} ${e[1] - 3.5}v7`);
  return (
    <g className={'text-ink-3'} strokeWidth={'0.9'}>
      <path
        d={`M${e[0]} ${e[1]}L${t[0]} ${t[1]}`}
        pathLength={1}
        data-on={Om(n, r)}
        className={'pd-line pd-line-fast'}
      />
      <path
        d={`${a(e)}${a(t)}`}
        data-on={Om(n, r + 160)}
        className={'pd-fade'}
      />
      {translateShowcaseNode(
        showcaseCopy,
        [e, t].map((e) => (
          <circle
            key={`${e[0]}-${e[1]}`}
            cx={e[0]}
            cy={e[1]}
            r={'1.4'}
            fill={'currentColor'}
            stroke={'none'}
            data-on={Om(n, r + 160)}
            className={'pd-fade'}
          />
        ))
      )}
    </g>
  );
}
export function DrawingDimension({ d: e, t, ms: n }) {
  return (
    <path
      d={e}
      data-on={Om(t, n - 120)}
      className={'pd-fade pd-dash text-ink-4'}
      strokeWidth={'0.6'}
    />
  );
}
export const Mm = {
  A: {
    x: 122,
    y: 264,
  },
  B: {
    x: 22,
    y: 180,
    rotate: !0,
  },
  C: {
    x: 264,
    y: 264,
  },
  D: {
    x: 126,
    y: 76,
    side: !0,
  },
  E: {
    x: 163,
    y: 98,
    side: !0,
  },
};
export function TechpackSchematic({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'relative'}>
      <svg
        viewBox={`${Em.x} ${Em.y} ${Em.w} ${Em.h}`}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={'1.15'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        aria-hidden={!0}
        className={'text-ink block h-auto w-full'}
      >
        <Scene_km
          t={e}
          ms={0}
          d={
            'M48 120H196Q198 120 198 122V238Q198 240 196 240H48Q46 240 46 238V122Q46 120 48 120Z'
          }
        />
        <Scene_km
          t={e}
          ms={600}
          dashed={!0}
          className={'text-ink-3'}
          d={'M49.5 124H194.5M49.5 124V236.5H194.5V124'}
        />
        <Scene_km t={e} ms={380} d={'M85 147V120C85 13 159 13 159 120V147'} />
        <Scene_km t={e} ms={520} d={'M95 147V120C95 27 149 27 149 120V147'} />
        <Scene_km t={e} ms={760} d={'M85 147H95M149 147H159'} />
        <Scene_km
          t={e}
          ms={900}
          dashed={!0}
          className={'text-ink-3'}
          d={'M87.2 128h5.6v16.6h-5.6ZM151.2 128h5.6v16.6h-5.6Z'}
        />
        <Scene_km
          t={e}
          ms={980}
          dashed={!0}
          className={'text-ink-3'}
          d={'M87.5 118C87.5 18 156.5 18 156.5 118'}
        />
        <Scene_km
          t={e}
          ms={1450}
          dashed={!0}
          className={'text-ink-4'}
          d={'M86 168H158V206H86Z'}
        />
        <Scene_km
          t={e}
          ms={1e3}
          d={
            'M238 120H290Q292 120 292 122V238Q292 240 290 240H238Q236 240 236 238V122Q236 120 238 120Z'
          }
        />
        <Scene_km
          t={e}
          ms={1200}
          dashed={!0}
          className={'text-ink-3'}
          d={'M239.5 124V236.5H288.5V124'}
        />
        <Scene_km
          t={e}
          ms={1300}
          d={'M262 147V40.5M266 147V40.5M262 40.5Q264 38 266 40.5'}
        />
        <DrawingDimension t={e} ms={1900} d={'M46 244V268M198 244V268'} />
        <ToteDrawing t={e} ms={1900} a={[46, 262]} b={[198, 262]} />
        <DrawingDimension t={e} ms={2300} d={'M42 120H16M42 240H16'} />
        <ToteDrawing t={e} ms={2300} a={[22, 120]} b={[22, 240]} />
        <DrawingDimension t={e} ms={2700} d={'M236 244V268M292 244V268'} />
        <ToteDrawing t={e} ms={2700} a={[236, 262]} b={[292, 262]} />
        <DrawingDimension t={e} ms={3100} d={'M100 40H130'} />
        <ToteDrawing t={e} ms={3100} a={[122, 40]} b={[122, 120]} />
        <DrawingDimension t={e} ms={3500} d={'M149 92V104M159 92V104'} />
        <ToteDrawing t={e} ms={3500} a={[149, 98]} b={[159, 98]} />
      </svg>
      {translateShowcaseNode(
        showcaseCopy,
        Dm.map((t) => {
          let n = Mm[t.code];
          return n ? (
            <span
              key={t.code}
              data-on={Om(e, t.at + 300)}
              className={'pd-pop pointer-events-none absolute'}
              style={{
                left: `${((n.x - Em.x) / Em.w) * 100}%`,
                top: `${((n.y - Em.y) / Em.h) * 100}%`,
                translate: n.side ? '0 -50%' : '-50% -50%',
                rotate: n.rotate ? '-90deg' : void 0,
              }}
            >
              <span
                className={
                  'pd-sheet text-ink flex h-[18px] items-center gap-1 rounded-[5px] px-1.5 font-mono text-[10.5px] leading-none whitespace-nowrap shadow-[inset_0_0_0_1px_var(--border)] sm:text-[11px]'
                }
              >
                <span className={'font-semibold'}>
                  {translateShowcaseNode(showcaseCopy, t.code)}
                </span>
                <span className={'num text-ink-3'}>
                  {translateShowcaseNode(showcaseCopy, t.cm)}
                </span>
              </span>
            </span>
          ) : null;
        })
      )}
    </div>
  );
}
export function Pm(e, t = 0.72) {
  let n = Number.parseInt(e.slice(1), 16),
    r = (e) => Math.min(255, Math.round(((n >> e) & 255) * t));
  return `rgb(${r(16)} ${r(8)} ${r(0)})`;
}
export const Fm =
  'h-8 border-b border-[var(--line)] px-2 text-left text-[12px] font-medium text-ink-3 whitespace-nowrap';
export const Im =
  'h-9 border-b border-[var(--line)] px-2 text-[13px] whitespace-nowrap';
